class UtmNotification extends HTMLElement {
  constructor() {
    super()
    this.props = { confirmText: '' }
    this.state = { message: '', status: 'idle', isDisplay: false }
  }

  async connectedCallback() {
    this.initProps()
    this.initState()

    this.render(this.getRenderData())
    this.initEventListener()
    await this.init()
  }

  initProps() {
    this.props.confirmText = this.getAttribute(':confirmText')
  }

  initState() {
    this.state = { message: this.props.confirmText }
  }

  updateState(updates) {
    this.state = { ...this.state, ...updates }
    this.render(this.getRenderData())
    this.initEventListener()
  }

  initEventListener() {
    this.querySelector('button[name="close"]').addEventListener('click', this.handleCloseButtonClick.bind(this))
  }

  handleCloseButtonClick() {
    this.updateState({ isDisplay: false })
  }

  async init() {
    const discountCode = this.getDiscountCode()
    if (!discountCode) return

    await this.applyDiscountCode(discountCode)
  }

  getDiscountCode() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('utm_code');
  }

  async applyDiscountCode(code) {
    await fetch(`/discount/${code}`)

    // Trigger GA event
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'coupon_code_added',
      'coupon_code': code,
      'coupon_code_method': 'auto_applied',
      'coupon_code_applied': true,
      'gtm.uniqueEventId': 1
    });

    sessionStorage.setItem("utm-code", code);

    this.updateState({ status: 'success', isDisplay: true, message: this.state.message.replace("{discount_code}", code.toUpperCase()) })

    setTimeout(() => this.updateState({ isDisplay: false }), 5000)
  }

  getRenderData() {
    const result = {}
    result.isDisplay = this.state.isDisplay
    result.message = this.state.message
    return result
  }

  render(data) {
    this.innerHTML = `
      <div class="fixed bottom-5 z-[9999] w-full transform px-5 sm:left-1/2 sm:top-[125px] sm:w-auto sm:-translate-x-1/2 sm:px-0">
        <div class="${data.isDisplay ? '!flex' : 'hidden'} w-full items-center rounded-lg bg-[#288E7C] p-5 text-white shadow-lg sm:w-max">
          <svg class="hidden sm:!block" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="v1" stroke="none" stroke-width="1" fill="white" fill-rule="evenodd">
              <g id="Notifications-/-Success" transform="translate(-8.000000, -8.000000)" fill="white" fill-rule="nonzero">
                <g id="Icons-/-success" transform="translate(8.000000, 8.000000)">
                  <path d="M2.01406557,8.51690623 C4.56197972,5.27692051 8.92133556,4.07120924 12.772011,5.54147213 C13.2881211,5.73974235 13.5457812,6.31886203 13.347511,6.83497213 C13.1492407,7.35108223 12.5701211,7.60874235 12.054011,7.41047213 C9.02367889,6.25516505 5.59416044,7.20526163 3.59031434,9.75521216 C1.58646824,12.3051627 1.47420548,15.8620823 3.31326146,18.5333218 C5.15231744,21.2045612 8.51509626,22.3690348 11.6122516,21.4071223 C14.7094069,20.4452097 16.8208242,17.5805636 16.823011,14.3374721 C16.823011,14.1674721 16.817011,13.9984721 16.805011,13.8304721 C16.7874581,13.5657746 16.8757997,13.3049492 17.0505933,13.1053995 C17.2253868,12.9058497 17.4723072,12.7839297 17.737011,12.7664721 C18.0030271,12.7475496 18.2655815,12.8356686 18.4663198,13.0112442 C18.6670581,13.1868198 18.7893484,13.4353048 18.806011,13.7014721 C18.820011,13.9134721 18.828011,14.1264721 18.828011,14.3414721 C18.8257027,18.4632883 16.1422725,22.1042944 12.2058867,23.326686 C8.26950095,24.5490775 3.99565089,23.0685612 1.65895105,19.6730924 C-0.677748789,16.2776237 -0.533848584,11.756892 2.01406557,8.51690623 Z M22.3626459,0.00724130913 C22.6923617,-0.0283935117 23.0227244,0.0684566501 23.281011,0.276472127 C23.5398526,0.484228358 23.7054411,0.786398385 23.7412704,1.11636494 C23.7770996,1.44633149 23.6802276,1.77700064 23.472011,2.03547213 L23.472011,2.03547213 L9.91501096,18.8604721 C9.69051957,19.1336921 9.36162251,19.3000972 9.00851634,19.319112 C8.65541018,19.3381269 8.310545,19.2080041 8.05801096,18.9604721 L8.05801096,18.9604721 L4.42201096,15.3254721 C4.10618817,15.0096493 3.98284533,14.5493276 4.09844449,14.1179057 C4.21404365,13.6864837 4.55102255,13.3495048 4.9824445,13.2339057 C5.41386645,13.1183065 5.87418818,13.2416493 6.19001096,13.5574721 L6.19001096,13.5574721 L8.84101096,16.2084721 L21.523011,0.466472127 C21.7308889,0.208074822 22.03293,0.0428761299 22.3626459,0.00724130913 Z" id="Combined-Shape"></path>
                </g>
              </g>
            </g>
          </svg>
          <p class="mr-auto font-semibold leading-none text-white sm:mr-6 flex-1">${data.message}</p>
          <button class="ml-2 sm:ml-0" name="close">
            <svg class="sm:h-4 sm:w-4" width="24" height="25" viewBox="0 0 24 25" fill="white" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.4099 12.9885L19.7099 6.69847C19.8982 6.51016 20.004 6.25477 20.004 5.98847C20.004 5.72217 19.8982 5.46677 19.7099 5.27847C19.5216 5.09016 19.2662 4.98438 18.9999 4.98438C18.7336 4.98438 18.4782 5.09016 18.2899 5.27847L11.9999 11.5785L5.70994 5.27847C5.52164 5.09016 5.26624 4.98438 4.99994 4.98438C4.73364 4.98438 4.47824 5.09016 4.28994 5.27847C4.10164 5.46677 3.99585 5.72217 3.99585 5.98847C3.99585 6.25477 4.10164 6.51016 4.28994 6.69847L10.5899 12.9885L4.28994 19.2785C4.19621 19.3714 4.12182 19.482 4.07105 19.6039C4.02028 19.7257 3.99414 19.8565 3.99414 19.9885C3.99414 20.1205 4.02028 20.2512 4.07105 20.373C4.12182 20.4949 4.19621 20.6055 4.28994 20.6985C4.3829 20.7922 4.4935 20.8666 4.61536 20.9174C4.73722 20.9681 4.86793 20.9943 4.99994 20.9943C5.13195 20.9943 5.26266 20.9681 5.38452 20.9174C5.50638 20.8666 5.61698 20.7922 5.70994 20.6985L11.9999 14.3985L18.2899 20.6985C18.3829 20.7922 18.4935 20.8666 18.6154 20.9174C18.7372 20.9681 18.8679 20.9943 18.9999 20.9943C19.132 20.9943 19.2627 20.9681 19.3845 20.9174C19.5064 20.8666 19.617 20.7922 19.7099 20.6985C19.8037 20.6055 19.8781 20.4949 19.9288 20.373C19.9796 20.2512 20.0057 20.1205 20.0057 19.9885C20.0057 19.8565 19.9796 19.7257 19.9288 19.6039C19.8781 19.482 19.8037 19.3714 19.7099 19.2785L13.4099 12.9885Z" fill="white" />
            </svg>
          </button>
        </div>
      </div>
    `
  }
}

customElements.define('utm-notification', UtmNotification);